/** One action name for every decision point, with `guard` and `outcome` as dimensions. */
export const CTA_GUARD_ACTION = 'vdp-cta-guard';

/**
 * Identifies the purchase CTA to the shared account modal, and doubles as the filter keeping the
 * account-modal-emit guard out of the other callers that open the same modal.
 */
export const PURCHASE_CALLER_IDENTIFIER = 'StartPurchase';

export enum CtaGuard {
  AccountModalEmit = 'account-modal-emit',
  ConfirmAfterLogin = 'confirm-after-login',
  ConfirmBeforeLogin = 'confirm-before-login',
  Dispatch = 'dispatch',
  Login = 'login',
  PartnerModal = 'partner-modal',
  Readiness = 'readiness',
  StartPurchase = 'start-purchase'
}

/**
 * There is no abandoned outcome: the VDP modal context exposes only `onContinue`, with no close or
 * cancel callback to hook, so abandonment is derived at query time as `1 - continued/opened`.
 */
export enum CtaGuardOutcome {
  Attempt = 'attempt',
  Continued = 'continued',
  Deferred = 'deferred',
  DeferredResolved = 'deferred-resolved',
  Delivered = 'delivered',
  Dropped = 'dropped',
  Noop = 'noop',
  Opened = 'opened',
  Passed = 'passed',
  Queued = 'queued',
  Success = 'success'
}

/**
 * How the purchase intent leaves this app. Both are successful hand-offs and share the `attempt`
 * outcome, so webview traffic does not read as a drop-off at the terminal guard.
 */
export enum CtaHandoff {
  Native = 'native',
  Navigation = 'navigation'
}

export enum CtaSource {
  PriceDetails = 'priceDetails',
  Primary = 'primary'
}
